<template>
    <div>
        <v-dialog
            v-model="display"
            width="350"
            persistent>
            <v-card flat>
                <v-card-title>{{ $t('print') }}</v-card-title>
                <v-card-text v-if="loading.data">
                    {{ $t('print_msg') }}
                    <!-- <div id="printOrder" style="font-family: 'Cairo', sans-serif"> -->
                    <div id="printOrder" style="display: none; font-family: 'Cairo', sans-serif" >
                        <div>
                            <div class="row">
                                <div class="col-sm">  
                                    <div>
                                        <h4 class="text-left">Petra Ready Mixed Concrete</h4>
                                        <h4 style="font-weight: bold;" class="text-left"><p>{{ $t('sales_order_title') }}</p></h4>
                                        <p class="text-left">khartoum - sudan Industrial Area, Gabra Square.</p>
                                        <p class="text-left"> +249912809360-+249187114000</p>
                                    </div>
                                </div>
                                <div class="col-sm">
                                    <img style="float: right;" class="text-right"  width="150" src="../../assets/petralogo.png" alt="">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm"> 
                                    <div v-if="salesOrder" class="text-center">
                                        <h3>
                                            <b>{{ this.$t('sales_order_number') }} {{salesOrder.code}}</b>
                                        </h3>
                                    </div>
                                </div>
                             </div>
                            <br>
                            <div class="row">
                                <div v-if="salesOrder" class="col-sm">
                                    <h5 class="text-left">{{ $t('title_info') }} :</h5>
                                    <table style="border-collapse: collapse; border: none; " class="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <th>{{$t('date')}} :</th>
                                                <td>{{ salesOrder.date }}</td>
                                                <th>{{$t('validity_date')}} : </th>
                                                <td>{{ salesOrder.validity_date }}</td>
                                            </tr>
                                            <tr>
                                                <th>{{$t('customer_acc')}} :</th>
                                                <td colspan="4">{{ salesOrder.customer_code }}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t('customer') }} :</th>
                                                <td colspan="4">{{ salesOrder.customer }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="salesOrder" class="row">
                                <div class="col-sm">
                                    <table class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th>{{ $t('concrete') }}</th>
                                                <th>{{ $t('type') }}</th>
                                                <th>{{ $t('quantity') }}</th>
                                                <th>{{ $t('unit_measure') }}</th>
                                                <th>{{ $t('price') }}</th>
                                                <th>{{ $t("tax") }}</th>
                                                <th>{{ $t('total') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="itemLine in salesOrder.sales_order_item_lines" :key="itemLine.id">
                                                <td>{{ itemLine.item }}</td>
                                                <td>{{ itemLine.cast_type }}</td>
                                                <td>{{ itemLine.quantity }}</td>
                                                <td>{{ itemLine.measure_unit }}</td>
                                                <td>{{ formatPrice(itemLine.price) }}</td>
                                                <td>{{ formatPrice(itemLine.tax) }}</td>
                                                <td><b>{{ formatPrice(itemLine.total) }}</b></td>
                                            </tr>
                                            <tr>
                                                <td colspan="5"></td>
                                                <th>{{ $t('total') }}</th>
                                                <td colspan="3"><b>{{ formatPrice(salesOrder.total) }}</b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="salesOrder" class="row">
                                <div class="col-sm">
                                    <h5 class="text-left">Terms:</h5>
                                    <ol class="text-left" style="font-size: 14px;">
                                        <li>Prices above are only valid before the sales order validity date. The customer wiil then be charged with the new prices after exceeding the sales order quantities or validity date.</li>
                                        <li>The customer must pay the value of delivered concrete in excess of the quantity required in the agreement by him or his representative within a maximum period of 72 hours (3 working days) from the date of completion of the casting.</li>
                                        <li>if custmer has exceeds the above stated paymnet period in clause 2 , the customer will be required to pay the amount of pured excess quantity at the current price. </li>
                                        <li>If the customer or his respresentative wishes to change the specifications of the perviously agreed concrete mixture, he or his respresentative must noyify the company (petra) 48 hours before the date of casting, any amount pourd from the previous mixture specifications befire this notification is considered a qunatity received by the customer and deducted of the total quantity demanded, a change to the new specifications is made in the remaining quantity onlyof the agreed sales order.</li>
                                        <li>If the customer want to refund the undelivered ready concrete value that has not been received by him or his representative, the customer must provide  the payment receipt  which was made for initial ready concrete booking.</li>
                                        <li>Prices does not include the fees of concrete placement workers and lab services</li>
                                        <li>This agreement is valid until the end of the date shown above. In the event that the customer does not implement his project until that date, Petra Factory has the right to cancel or amend the agreement.</li>
                                        <li>If casting is desired, the customer must make a reservation 96 hours before the casting date.</li>
                                    </ol>
                                </div>
                                <div class="col-sm text-right">
                                    <h5> : الاحكام عامه</h5>
                                    <ol style="direction: rtl; font-size: 14px;" class="text-right">
                                        <li>الأسعار أعلاه صالحة فقط حتي نهاية تاريخ الصلاحية الموضح اعلاه. سيتم بعد ذلك تحميل العميل بالأسعار الجارية لنفس امر .</li>
                                        <li>يجب علي العميل سداد قيمة الخرسانة المسلمه الزائدة عن الكمية المطلوبة في الأتفاق بواسطته او ممثله في فترة أقصاها 72 ساعة (3 أيام عمل)من تاريخ انتهاء الصب.</li>
                                        <li>في حالة تجاوز العميل للفترة السداد الموضحة في البند 2 يتم مطالبة العميل بقيمة الكميات الزائدة بسعر اليوم.</li>
                                        <li>إذا رغب العميل او ممثله في تغيير مواصفات خلطة الخرسانة المطلوبة بواسطته يجب عليه او علي ممثله إخطار الشركة (بيترا) خطياً قبل 48 ساعة من تاريخ الصب وأي كمية تم صبها من مواصفات الخلطة السابقة قبل هذا الإخطار تعتبر كمية مستلمة بواسطة العميل وتخصم من اجمالى الكمية المطلوبة, ويتم إجراء تغيير المواصفات الجديدة في الكمية المتبقية فقط من أمر البيع المتفق علية.</li>
                                        <li>أذا رغب العميل في إسترداد قيمة متبقي الخرسانة التي لم يتم إستلامها بواسطته او ممثله ، يجب عاي العميل إحضار إيصال التوريد المالي الذي تم به الحجز الاولى </li>
                                        <li>الأسعار لا تشمل أعمال القدة والمعمل</li>
                                        <li>هذه الإتفاقية صالحة حتى نهاية التاريخ الموضح اعلاه. في حال لم يقوم العميل بتنفيذ مشروعه حتى ذلك التاريخ، بمصنع بيترا الحق في إلغاء او تعديل الاتفاق</li>
                                        <li>في حالة الرغبة في تنفيذ الصب على العميل الحجز قبل 96 ساعة من تاريخ الصب</li>
                                    </ol>
                                </div>
                                <div v-if="salesOrder" class="row">
                                    <div class="col-sm text-left">
                                        <ol style="font-size: 14px;">
                                            <ul>
                                                <li>
                                                    All above stated data is responsibility of the above stated cutomer or his/her representative, all these data shall be deeming as a greed contractual trems between the customer and petra company in order to execute and deliver this order .
                                                </li>
                                            </ul>
                                        </ol>
                                    </div>
                                    <div class="col-sm text-right">
                                        <ol style="direction: rtl; font-size: 14px;">
                                            <ul>
                                                <li>
                                                    جميع البيانات أعلاه هي مسؤولية العميل المذكور أعلاه او من يمثله, وتعتبر هذه البيانات بمثابة شروط تعاقدية متفق عليها بين العميل وشركة بيترا من أجل تنفيذ وتسليم هذا الطلب.
                                                </li>
                                            </ul>
                                        </ol>
                                    </div>
                                 </div>
                             </div>
                             <br>
                             <br>
                             <br>
                            <div v-if="salesOrder"  class="row">
                                 <div class="col-sm">
                                    <table class="table table-bordered table-sm">
                                            <tr>
                                                <td>
                                                    <h5>Petra RMC: ..................................</h5>
                                                    <h5>Signature: ..................................</h5>
                                                    <h5>Date: .......................................</h5>
                                                </td>
                                                <td>
                                                    <h5>Customer: ...............................</h5>
                                                    <h5>Signature: ...................................</h5>
                                                    <h5>Date: ........................................</h5>
                                                </td>
                                            </tr>
                                    </table>
                                 </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="print" text>
                        {{ $t('print') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import { mapActions, mapState } from 'vuex';
import {formatMoney} from 'accounting';

export default {
    name: "SalesOrderPrintDialog",
    components: {
        RetryDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            loading: {
                data: true
            }
        }
    },
    computed: {
        ...mapState('sales/salesOrder', ["salesOrder"])
    },
    methods: {
        formatPrice(amount) {
            return formatMoney(amount, "SDG ", 2);
        },
        ...mapActions("sales/salesOrder", ["fetchSalesOrder"]),
        open(params) {
            this.openParams = params;
            this.loading.data = true;
            this.display = true;
        },
        async openDataFetch() {
            try {
                await this.fetchSalesOrder(this.openParams.id)
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({message});
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        close() {
            this.display = false;
        },
        print() {
            this.$htmlToPaper("printOrder");
            this.close();
        }
       
    },
}
</script>